export const reportChartConfigs = {
  live_job_pipeline_chart: {
    title: 'Current job pipeline',
    metricDefinition: 'Current snapshot of candidates across jobs',
    id: 'live_job_pipeline',
    defaultChart: 'horizontalStackedBar',
    basedOn: 'Application creation date',
    category: 'Current job pipeline',
    xTitle: 'Pipeline stage',
    yTitle: 'Number of candidates',
    hideAxisValues: true,
    legendOrderMatchesChart: true,
    singleSeriesData: {
      name: 'Candidates',
      color: '#605AFB',
    },
    skipDt: true,
    legendName: 'Applicants',
    isPipeline: true,
    chartContainerStyle: {
      height: '400px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    chartStyle: {
      width: '100%',
      height: '100%',
    },
  },
  pipeline_chart: {
    title: 'Pipeline history',
    metricDefinition: 'Comprehensive breakdown of the pipeline data',
    id: 'pipeline',
    defaultChart: 'pyramid',
    basedOn: 'Application creation date',
    category: 'Pipelines',
    alternatives: ['bar', 'column'],
    xTitle: 'Pipeline stage',
    yTitle: 'Number of candidates',
    singleSeriesData: {
      name: 'Candidates',
      color: '#605AFB',
    },
    legendName: 'Applicants',
    isPipeline: true,
    chartContainerStyle: {
      height: '400px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    chartStyle: {
      width: '900px',
      height: '100%',
    },
  },

  // interview charts
  interviews_trend_chart: {
    title: 'Completed interviews trend',
    metricDefinition: 'Trend of the completed interviews',
    id: 'interviews_trend_chart',
    yTitle: 'Number of interviews',
    xTitle: 'Time period',
    singleSeriesData: {
      name: 'Number of completed interviews',
      color: '#605AFB',
    },
    defaultChart: 'area',
    alternatives: ['bar', 'column'],
    basedOn: 'Interview date',
    category: 'Interviews',
  },

  interviews_feedback_chart: {
    title: 'Completed interviews by feedback',
    seriesName: true,
    metricDefinition: 'Completed interviews broken down by feedback',
    id: 'interviews_trend_chart',
    defaultChart: 'pie',
    alternatives: ['bar', 'column'],
    basedOn: 'Interview date',
    category: 'Interviews',
    xTitle: 'Feedback type',
    yTitle: 'Number of interviews',
    singleSeriesData: {
      name: 'Interviews',
      color: '#605AFB',
    },
    legendName: 'Interviews',
  },

  interviews_duration_chart: {
    title: 'Completed interviews by duration',
    seriesName: false,
    metricDefinition: 'Completed interviews broken down by duration',
    id: 'interviews_duration_chart',
    defaultChart: 'pie',
    alternatives: ['bar', 'column'],
    basedOn: 'Interview date',
    category: 'Interviews',
    xTitle: 'Duration range',
    yTitle: 'Number of interviews',
    singleSeriesData: {
      name: 'Interviews',
      color: '#605AFB',
    },
    legendName: 'Interviews',
  },

  //offer charts
  offers_trend_chart: {
    title: 'Offer trend',
    metricDefinition: 'Trend of offers created',
    id: 'interviews_duration_chart',
    yTitle: 'Number of offers',
    xTitle: 'Time period',
    singleSeriesData: {
      name: 'Offers',
      color: '#605AFB',
    },
    defaultChart: 'column',
    alternatives: ['bar', 'area'],
    basedOn: 'Offer creation date',
    category: 'Offers',
  },

  offers_department_chart: {
    title: 'Offers by department',
    metricDefinition: 'Offers broken down by department',
    id: 'offers_department_chart',
    defaultChart: 'pie',
    alternatives: ['bar', 'column'],
    basedOn: 'Offer creation date',
    category: 'Offers',
    xTitle: 'Department',
    yTitle: 'Number of offers',
    singleSeriesData: {
      name: 'Offers',
      color: '#605AFB',
    },
    legendName: 'Offers',
  },

  offers_location_chart: {
    title: 'Offers by location',
    metricDefinition: 'Offers broken down by location',
    id: 'offers_location_chart',
    defaultChart: 'pie',
    alternatives: ['bar', 'column'],
    basedOn: 'Offer creation date',
    category: 'Offers',
    xTitle: 'Location',
    yTitle: 'Number of offers',
    singleSeriesData: {
      name: 'Offers',
      color: '#605AFB',
    },
    legendName: 'Offers',
  },

  //hires charts
  hires_trend_chart: {
    title: 'Hire trend',
    metricDefinition: 'Trend of the hires made',
    id: 'hires_trend_chart',
    yTitle: 'Number of hires',
    xTitle: 'Time period',
    singleSeriesData: {
      name: 'No of Hires',
      color: '#605AFB',
    },
    defaultChart: 'area',
    alternatives: ['bar', 'column'],
    basedOn: 'Hire date',
    category: 'Hires',
  },

  hires_department_chart: {
    title: 'Hires by department',
    metricDefinition: 'Hires broken down by department',
    id: 'hires_department_chart',
    defaultChart: 'pie',
    alternatives: ['bar', 'column'],
    basedOn: 'Hire date',
    category: 'Hires',
    xTitle: 'Department',
    yTitle: 'Number of hires',
    singleSeriesData: {
      name: 'Hires',
      color: '#605AFB',
    },
    legendName: 'Hires',
  },

  hires_source_chart: {
    title: 'Hire by source (on application)',
    metricDefinition: 'Hires broken down by source',
    id: 'hires_source_chart',
    singleSeriesData: {
      name: 'Hires',
      color: '#605AFB',
    },
    defaultChart: 'bar',
    alternatives: ['area', 'column'],
    basedOn: 'Hire date',
    category: 'Hires',
    xTitle: 'Source',
    yTitle: 'Number of hires',
    skipDt: true,
  },

  // rejections chart
  rejections_trend_chart: {
    title: 'Rejected trend',
    metricDefinition: 'Trend of rejections done',
    id: 'rejections_trend_chart',
    yTitle: 'Number of rejections',
    xTitle: 'Time period',
    singleSeriesData: {
      name: 'Number of candidates',
      color: '#605AFB',
    },
    defaultChart: 'area',
    alternatives: ['bar', 'column'],
    basedOn: 'Rejection date',
    category: 'Rejections',
  },

  //rejection reason
  we_rejected_them: {
    title: 'We rejected them',
    metricDefinition: 'Split of the rejected reasons',
    id: 'we_rejected_them',
    defaultChart: 'pie',
    alternatives: ['bar', 'column'],
    basedOn: 'Rejection date',
    category: 'Rejections',
    xTitle: 'Reason',
    yTitle: 'Number of rejections',
    singleSeriesData: {
      name: 'Rejections',
      color: '#605AFB',
    },
    legendName: 'Rejections',
  },

  they_rejected_us: {
    title: 'They rejected us',
    metricDefinition: 'Split of the rejected reasons',
    id: 'they_rejected_us',
    defaultChart: 'pie',
    alternatives: ['bar', 'column'],
    basedOn: 'Rejection date',
    category: 'Rejections',
    xTitle: 'Reason',
    yTitle: 'Number of rejections',
    singleSeriesData: {
      name: 'Rejections',
      color: '#605AFB',
    },
    legendName: 'Rejections',
  },

  others: {
    title: 'Others',
    metricDefinition: 'Split of the rejected reasons',
    id: 'others',
    defaultChart: 'pie',
    alternatives: ['bar', 'column'],
    basedOn: 'Rejection date',
    category: 'Rejections',
    xTitle: 'Reason',
    yTitle: 'Number of rejections',
    singleSeriesData: {
      name: 'Rejections',
      color: '#605AFB',
    },
    legendName: 'Rejections',
  },

  //rejection visual
  rejection_by_stage: {
    title: 'Rejection by stage',
    metricDefinition: 'Rejections broken down by stage',
    id: 'rejection_by_stage',
    singleSeriesData: {
      name: 'Rejections',
      color: '#605AFB',
    },
    defaultChart: 'bar',
    alternatives: ['area', 'column'],
    basedOn: 'Rejection date',
    category: 'Rejections',
    xTitle: 'Stage',
    yTitle: 'Number of rejections',
    skipDt: true,
  },

  rejection_by_source: {
    title: 'Rejections by source (on application)',
    metricDefinition: 'Rejections broken down by source (on application)',
    id: 'rejection_by_source',
    singleSeriesData: {
      name: 'Rejections',
      color: '#605AFB',
    },
    defaultChart: 'bar',
    alternatives: ['area', 'column'],
    basedOn: 'Rejection date',
    category: 'Rejections',
    xTitle: 'Source',
    yTitle: 'Number of rejections',
    skipDt: true,
  },

  // contact charts
  contacts_chart: {
    title: 'New contact trend by source (on contact)',
    metricDefinition:
      'Trend of new contacts broken down by source (on contact)',
    id: 'chart_table',
    defaultChart: 'column',
    alternatives: ['bar', 'area'],
    basedOn: 'Contact creation date',
    category: 'Contacts',
    xTitle: 'Time period',
    yTitle: 'Number of contacts',
    singleSeriesData: {
      name: 'Contacts',
    },
  },

  //jobs charts
  jobs_trend_chart: {
    title: 'Job open trend',
    metricDefinition: 'Trend of jobs opened',
    yTitle: 'Number of jobs',
    xTitle: 'Time period',
    id: 'jobs_trend_chart',
    defaultChart: 'column',
    alternatives: ['bar', 'area'],
    basedOn: 'Job open date',
    category: 'Jobs',
  },

  jobs_department_chart: {
    title: 'Jobs opened by department',
    metricDefinition: 'New jobs broken down by department',
    id: 'jobs_department_chart',
    defaultChart: 'pie',
    alternatives: ['bar', 'column'],
    basedOn: 'Job open date',
    category: 'Jobs',
    xTitle: 'Department',
    yTitle: 'Number of jobs',
    singleSeriesData: {
      name: 'Jobs',
      color: '#605AFB',
    },
    legendName: 'Jobs',
  },

  jobs_location_chart: {
    title: 'Jobs opened by location',
    metricDefinition: 'New jobs broken down by location',
    id: 'jobs_location_chart',
    defaultChart: 'pie',
    alternatives: ['bar', 'column'],
    basedOn: 'Job open date',
    category: 'Jobs',
    xTitle: 'Location',
    yTitle: 'Number of jobs',
    singleSeriesData: {
      name: 'Jobs',
      color: '#605AFB',
    },
    legendName: 'Jobs',
  },

  //flow charts
  flow_candidate_touchpoint_chart: {
    title: 'Candidate touchpoint',
    metricDefinition: 'Split of the various candidate touchpoints in Flows',
    id: 'flow_candidate_touchpoint_chart',
    defaultChart: 'column',
    alternatives: ['bar', 'area'],
    basedOn: 'Flow creation date',
    category: 'Flows',
    xTitle: 'Touchpoint',
    yTitle: 'Number of candidates',
    singleSeriesData: {
      name: 'Candidates',
      color: '#605AFB',
    },
  },

  flow_user_activity_chart: {
    title: 'User activity',
    metricDefinition: 'Split of the various user activities in Flows',
    id: 'flow_user_activity_chart',
    defaultChart: 'column',
    alternatives: ['bar', 'area'],
    basedOn: 'Flow creation date',
    category: 'Flows',
    xTitle: 'Activity',
    yTitle: 'Number of activities',
    singleSeriesData: {
      name: 'Activities',
      color: '#605AFB',
    },
  },

  //requisitions charts
  requisitions_trend_chart: {
    title: 'Trend of requisitions opened',
    metricDefinition:
      'The trend of requisition openings across a time period. ',
    id: 'requisitions_trend_chart',
    yTitle: 'Requisitions openeds',
    xTitle: 'Number of requisitions opened',
    singleSeriesData: {
      name: 'No of requisitions',
      color: '#605AFB',
    },
    defaultChart: 'area',
    alternatives: ['bar', 'column'],
    basedOn: 'Requisition open date',
    category: 'Requisitions',
  },

  requisitions_by_department: {
    title: 'Requisitions by department',
    metricDefinition:
      'Number of requisitions marked as open during the selected time period broken down by department',
    id: 'requisitions_by_department',
    singleSeriesData: {
      name: 'Requisitions',
      color: '#605AFB',
    },
    defaultChart: 'bar',
    alternatives: ['area', 'column'],
    basedOn: 'Requisition open date',
    category: 'Requisitions',
    xTitle: 'Department',
    yTitle: 'Number of requisitions',
    skipDt: true,
  },

  requisitions_by_requisition_type: {
    title: 'Requisitions by requisition type',
    metricDefinition:
      'Number of requisitions marked as open during the selected time period broken down by requisition type ',
    id: 'requisitions_by_requisition_type',
    singleSeriesData: {
      name: 'Requisitions',
      color: '#605AFB',
    },
    defaultChart: 'bar',
    alternatives: ['area', 'column'],
    basedOn: 'Requisition open date',
    category: 'Requisitions',
    xTitle: 'Requisition type',
    yTitle: 'Number of requisitions',
    skipDt: true,
  },
  requisitions_by_department_pie: {
    title: 'Percentage of requisitions filled by department',
    metricDefinition:
      'The percentage of the requisitions filled during the selected time period broken down by department',
    id: 'requisitions_by_department_pie',
    singleSeriesData: {
      name: 'Requisitions',
      color: '#605AFB',
    },
    defaultChart: 'pie',
    alternatives: ['bar', 'column'],
    basedOn: 'Requisition open date',
    category: 'Requisitions',
    xTitle: 'Department',
    yTitle: 'Number of requisitions',
    skipDt: true,
    legendName: 'Requisitions',
  },

  //survey charts
  survey_candidate_nps_chart: {
    title: 'Candidate NPS over time',
    metricDefinition:
      'The trend of aggregate NPS from candidate surveys across a period of time',
    id: 'survey_candidate_nps_chart',
    singleSeriesData: {
      name: 'Candidate NPS',
      color: '#605AFB',
    },
    defaultChart: 'area',
    alternatives: ['bar', 'column'],
    basedOn: 'Submission date',
    category: 'Survey',
    xTitle: '',
    skipDt: true,
  },
  survey_hm_nps_chart: {
    title: 'HM NPS over time',
    metricDefinition:
      'The trend of aggregate NPS from HM surveys across a period of time ',
    id: 'survey_hm_nps_chart',
    singleSeriesData: {
      name: 'HM NPS',
      color: '#605AFB',
    },
    defaultChart: 'area',
    alternatives: ['bar', 'column'],
    basedOn: 'Submission date',
    category: 'Survey',
    yTitle: 'NPS',
    skipDt: true,
  },
};
